<template>
  <div class="btn-group">
    <button
      class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <img :src="require(`@/assets/${$i18n.locale}.svg`)" height="20"> {{ $t("localeName") }}
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
      <button
        v-for="sLocale in supportedLocales" :key="`locale-${sLocale}`" class="dropdown-item" type="button"
        :value="sLocale" :selected="locale === sLocale" @click="switchLanguage"
      >
        <img :src="require(`@/assets/${sLocale}.svg`)" height="20"> {{ t(`locale.${sLocale}`) }}
      </button>
    </ul>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Tr from '@/modules/localization/translation';

export default {
  setup() {
    const { t, locale } = useI18n();

    const supportedLocales = Tr.supportedLocales;

    const router = useRouter();

    const switchLanguage = async(event) => {
      const newLocale = event.target.value;
      await Tr.switchLanguage(newLocale);
      try {
        await router.replace({ params: { locale: newLocale } });
      } catch (e) {
        router.push('/');
      }
    };
    return { t, locale, supportedLocales, switchLanguage };
  },
};
</script>
